import "core-js/modules/es.function.name.js";
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  language: function language(state) {
    return state.app.language;
  },
  device: function device(state) {
    return state.app.device;
  },
  // visitedViews: state => state.tagsView.visitedViews,
  // cachedViews: state => state.tagsView.cachedViews,
  token: function token(state) {
    return state.user.token;
  },
  refleshToken: function refleshToken(state) {
    return state.user.refleshToken;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  isSuper: function isSuper(state) {
    return state.user.isSuper;
  },
  roleId: function roleId(state) {
    return state.user.roleId;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  status: function status(state) {
    return state.user.status;
  },
  setting: function setting(state) {
    return state.user.setting;
  },
  permission_routers: function permission_routers(state) {
    return state.permission.routers;
  },
  choosen_router: function choosen_router(state) {
    return state.permission.choosenRouters;
  },
  addRouters: function addRouters(state) {
    return state.permission.addRouters;
  },
  errorLogs: function errorLogs(state) {
    return state.errorLog.logs;
  },
  entSerno: function entSerno(state) {
    return state.user.entSerno;
  },
  menuTree: function menuTree(state) {
    return state.user.menuTree;
  },
  alarmData: function alarmData(state) {
    return state.user.alarmData;
  },
  isReal: function isReal(state) {
    return state.user.isReal;
  },
  realFilter: function realFilter(state) {
    return state.user.realFilter;
  },
  alarmRefresh: function alarmRefresh(state) {
    return state.user.refreshInfo.alarmRefresh;
  },
  cpcsRefresh: function cpcsRefresh(state) {
    return state.user.refreshInfo.cpcsRefresh;
  },
  buildId: function buildId(state) {
    return state.user.buildId;
  },
  nineRead: function nineRead(state) {
    return state.user.nineRead;
  }
};
export default getters;